import 'core-js/stable'
import 'regenerator-runtime/runtime'
import React from 'react';

import {createRoot} from 'react-dom/client';

import App from './App'

const container = document.getElementById('content_wrapper')
const root = createRoot(container)
root.render(<App/>)
